class OrderByMobile extends HTMLElement {
  constructor() {
    super();
    this.setOrder();
  }

  setOrder() {
    Shopify.queryParams = {};
    const form = this.querySelector('.sort-form');

    if (location.search.length) {
      for (let keyValue, i = 0, paramsArr = location.search.substr(1).split('&'); i < paramsArr.length; i++) {
        keyValue = paramsArr[i].split('=');

        if (paramsArr.length > 1) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
      }
    }
    // Adicionando tratamento de evento para clique e toque
    form.addEventListener('change', function (event) {
      const selectedSortOption = this.querySelector('input[name="sort-by"]:checked').value;
      Shopify.queryParams.sort_by = selectedSortOption;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
  }
}

customElements.define('order-content-mobile-form', OrderByMobile);